var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankNameIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17.111,
    viewBox: "0 0 22 17.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "address-card-regular",
    d: "M19.556,33.833a.613.613,0,0,1,.611.611V46.667a.613.613,0,0,1-.611.611H2.444a.613.613,0,0,1-.611-.611V34.444a.613.613,0,0,1,.611-.611ZM2.444,32A2.447,2.447,0,0,0,0,34.444V46.667a2.447,2.447,0,0,0,2.444,2.444H19.556A2.447,2.447,0,0,0,22,46.667V34.444A2.447,2.447,0,0,0,19.556,32Zm5.5,8.556A2.444,2.444,0,1,0,5.5,38.111,2.444,2.444,0,0,0,7.944,40.556ZM6.722,41.778a3.055,3.055,0,0,0-3.056,3.056.613.613,0,0,0,.611.611h7.333a.613.613,0,0,0,.611-.611,3.055,3.055,0,0,0-3.056-3.056Zm7.639-5.5a.917.917,0,0,0,0,1.833h3.056a.917.917,0,1,0,0-1.833Zm0,3.667a.917.917,0,0,0,0,1.833h3.056a.917.917,0,1,0,0-1.833Z",
    transform: "translate(0 -32)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNameIcon);
export default __webpack_public_path__ + "static/media/bank-name-icon.ddefb9306f7ff0440ac1a7a4f36a53b8.svg";
export { ForwardRef as ReactComponent };